// Angular imports
import { Component } from '@angular/core';

// Modal system imports
import { BaseModalComponent } from '../../modal/base-modal';
import { ModalService } from '../../modal/modal.service';

// Import types
import { LineComment } from '../../types';

// Types
export type LineCommentModalArgs = {
    comment?: LineComment
    done?: (comment: LineComment) => void;
}

// Constants
import { LINE_COMMENT_TYPE_CONFIGS, CommentType, LINE_COMMENT_TYPE_NONE_CONFIG } from '../../constants';

@Component({
    selector: 'line-comment-modal',
    templateUrl: './line-comment-modal.component.html',
    styleUrls: ['./line-comment-modal.component.scss'],
    standalone: false
})
export class LineCommentModalComponent extends BaseModalComponent {
    // Title for modal
    public title = 'Opmerking';

    // Properties
    public readonly _types: CommentType[] = LINE_COMMENT_TYPE_CONFIGS;
    public _selectedType: string = LINE_COMMENT_TYPE_NONE_CONFIG.id;
    public _text: string = '';

    private comment?: LineComment;
    private done?: (comment: LineComment) => void;

    constructor(private modalService: ModalService) {
        super();
    }

    public init(args: LineCommentModalArgs): void {
        // Read args
        this.comment = args.comment;
        this.done = args.done;

        // Set properties
        this._selectedType = this.comment?.type ?? LINE_COMMENT_TYPE_NONE_CONFIG.id;
        this._text = this.comment?.text ?? '';
    }

    private setSelectedType(typeId: string): void {
        // Update the type
        this._selectedType = typeId;
    }

    /* --- Event handlers --- */

    public _handleClickType(type: CommentType): void {
        this.setSelectedType(type.id);
    }
    
    public _handleClickDone(): void {
        // Close the modal
        this.modalService.close();

        // If done is not set, return
        if (this.done === undefined) return;
        this.done!({
            type: this._selectedType,
            text: this._text || undefined
        });
    }

    public _stopPropagation(event: Event) {
        event.stopPropagation();
    }
}
